exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news-head{font-weight:700;font-size:23px;line-height:41px;border-bottom:1px solid #eee;padding:15px;color:#686868}", ""]);

// exports
